import { useDataChange, useDataValue } from 'Simple/Data.js'

export function useOnFilterClickCorrection(props) {
  let current = useDataValue({
    context: 'tab',
    path: 'selected.ledger.transactions.filter_by',
    viewPath: props.viewPath,
  })

  let change = useDataChange({
    context: 'tab',
    path: 'selected.ledger.transactions.filter_by',
    viewPath: props.viewPath,
  })

  return function onClick() {
    if (current.length === 0) {
      change(['correction'])
      return
    }

    if (current.includes('correction')) {
      let newSelected = current.filter(item => item !== 'correction')
      change(newSelected)
    } else {
      change([...current, 'correction'])
    }
  }
}

export function getCount(transactions, type) {
  return transactions.filter(item => item.type === type).length
}
